export default __webpack_public_path__ + "images/logic-small-mountain.svg";